export const STATUS_POLL = 9000;

export enum Navigation {
  SUMMARY = "Summary"
}

export enum ScreenMode {
  ADD = "Add",
  VIEW = "View",
  EDIT = "Edit",
}

export enum ConfigurationType {
  SITES = "SITES",
  DSA = "DSA",
  CDB = "CDB"
}

export interface IResultCounts {
  included?: string;
  excluded?: string;
  population?: string;
}

export interface IPractice {
  name: string;
  cdb: string;
}

export interface IPracticeResults {
  practice: IPractice;
  counts: IResultCounts;
}

export interface IDSA {
  id: string;
  name: string;
  practices?: IPractice[];
}

export interface IExecutionConfigurationInput {
  artefactId: string;
  id?: string;
  name: string;
  type: string;
  relativeDate: string;
  dsa?: IDSA;
  cdb?: string;
  sites?: ISiteConfiguration[];
}

export interface IPractice {
  id: string;
  name: string;
  cdb: string;
  counts?: {
    included?: string;
    excluded?: string;
    population?: string;
  };
}

export interface ISiteConfiguration {
  id: string | null;
  expandedKey: string | null;
  name: string;
  postcode: string;
  radius: number;
  practices: IPractice[];
  counts?: IResultCounts;
}

export interface IExecutionConfiguration {
  id: string;
  configurationId: string;
  artefactId: string;
  status: string;
  createdBy: string;
  name: string;
  type: string;
  typeValue: string;
  included: string;
  excluded: string;
  relativeDate: string;
  relativeTime: string;
  runDate: string;
  runtime: string;
  dsa?: IDSA;
  cdb?: {
    cdbs?: string;
    practices: IPractice[];
  };
  sites?: ISiteConfiguration[];
  counts?: IResultCounts;
  isOlderThanFiveDays: boolean;
  cohortExecutionId: string;
}

export interface IExecutionHistoryList {
  needsRefresh: boolean;
  executions: IExecutionHistory[];
}

export interface IExecutionHistory {
  id: string;
  configurationId: string;
  name: string;
  status: string;
  type: string;
  createdDate: string;
  createdBy: string;
  counts?: IResultCounts;
}

export interface IError extends Error {
  errors: IErrorMessage[];
}

export interface IErrorMessage {
  message: string;
}

export interface IConfigSelection {
  ids: string[];
  type: string;
}
